module.exports = __webpack_public_path__ + "img/france-digestive-diseases-male.bf2ced2d.png";